import { render, staticRenderFns } from "./lobby.vue?vue&type=template&id=5540d44c&scoped=true"
import script from "./lobby.vue?vue&type=script&lang=js"
export * from "./lobby.vue?vue&type=script&lang=js"
import style0 from "./lobby.vue?vue&type=style&index=0&id=5540d44c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5540d44c",
  null
  
)

export default component.exports